var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-rolling",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "none",
    "ng-attr-stroke": "{{config.color}}",
    "ng-attr-stroke-width": "{{config.width}}",
    "ng-attr-r": "{{config.radius}}",
    "ng-attr-stroke-dasharray": "{{config.dasharray}}",
    stroke: "#3f51b5",
    strokeWidth: 7,
    r: 30,
    strokeDasharray: "141.37166941154067 49.12388980384689",
    transform: "rotate(353.237 50.0002 50.0002)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerBlue);
export default __webpack_public_path__ + "static/media/spinnerBlue.53cff62f245e5062fc6dd7910cc6f500.svg";
export { ForwardRef as ReactComponent };